import { SITE } from "@/lib/site";

// Adds someone to Klaviyo's subscribers list with email marketing consent. Only call this when the
// visitor has ticked an opt-in box or used the sign-up form.
//
// Route: our own /api/klaviyo-subscribe first (Pages Function, functions/api/klaviyo-subscribe.js),
// which ad blockers do not stop. If that route is not there (local `next dev`) or is unreachable, it
// falls back to Klaviyo's public client API directly. Resolves true only when Klaviyo accepted it.
export async function klaviyoSubscribe({ email, name, source }) {
  if (!email) return false;
  const src = source || "luluwild.co.uk website";

  try {
    const res = await fetch("/api/klaviyo-subscribe", {
      method: "POST",
      keepalive: true,
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email, name, source: src }),
    });
    if (res.ok) return true;
    // 400 = bad email; Klaviyo will say the same, so do not retry.
    if (res.status === 400) return false;
  } catch {}

  return klaviyoDirect({ email, name, source: src });
}

async function klaviyoDirect({ email, name, source }) {
  const [first, ...rest] = String(name || "").trim().split(/\s+/);
  const body = {
    data: {
      type: "subscription",
      attributes: {
        custom_source: source,
        profile: {
          data: {
            type: "profile",
            attributes: {
              email: String(email).trim(),
              first_name: first || undefined,
              last_name: rest.join(" ") || undefined,
              properties: { signup_source: source },
            },
          },
        },
      },
      relationships: { list: { data: { type: "list", id: SITE.klaviyo.listId } } },
    },
  };
  try {
    const res = await fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${SITE.klaviyo.companyId}`, {
      method: "POST",
      keepalive: true,
      headers: { "Content-Type": "application/json", revision: "2024-10-15" },
      body: JSON.stringify(body),
    });
    return res.ok;
  } catch {
    return false;
  }
}

// Resolves with the sign-up result, or false after `ms` so a slow Klaviyo never holds up a form.
export function klaviyoSubscribeWithin(ms, details) {
  return Promise.race([klaviyoSubscribe(details), new Promise((r) => setTimeout(() => r(false), ms))]);
}
